import Vue from "vue";
import Router from "vue-router";
import store from '@store';

Vue.use(Router);

const getComponent = (url) => {
  return () => import(`@page/${url}.vue`);
};

// 解决重复路由点击问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const router = new Router({
  mode: "history",
  routes: [
    {
      name: "home",
      path: "/",
      meta: {
        disableCheckUser: true,
        title: '首页'
      },
      component: getComponent("home/index"),
    },
    {
      name: "search",
      path: "/search",
      meta: {
        disableCheckUser: true,
        title: '搜索目的地'
      },
      component: getComponent("home/search"),
    },
    {
      name: "list",
      path: "/list",
      meta: {
        disableCheckUser: true,
        title: '签证列表'
      },
      component: getComponent("home/list"),
    },
    {
      name: "detail",
      path: "/detail",
      meta: {
        disableCheckUser: true,
        title: '签证详情'
      },
      component: getComponent("home/detail"),
    },
    {
      name: "user",
      path: "/user",
      meta: {
        title: '用户中心'
      },
      component: getComponent("user/index"),
    },
    {
      name: "login",
      path: "/login",
      meta: {
        disableCheckUser: true,
        title: '登录'
      },
      component: getComponent("user/login"),
    },
    {
      name: "register",
      path: "/register",
      meta: {
        disableCheckUser: true,
        title: '注册'
      },
      component: getComponent("user/register"),
    },
    {
      name: "address",
      path: "/address",
      meta: {
        title: '地址列表'
      },
      component: getComponent("user/address"),
    },
    {
      name: "addressSet",
      path: "/address_setting",
      meta: {
        title: '编辑地址'
      },
      component: getComponent("user/addressSet"),
    },
    {
      name: "order_list",
      path: "/order_list",
      meta: {
        title: '订单列表'
      },
      component: getComponent("order/list"),
    },
    {
      name: "order_detail",
      path: "/order_detail",
      meta: {
        title: '订单详情'
      },
      component: getComponent("order/detail"),
    },
    {
      name: "visa_push",
      path: "/visa_push",
      meta: {},
      component: getComponent("visa/push"),
    },
    {
      name: "visa_created",
      path: "/visa_created",
      meta: {
        keepAlive: true
      },
      component: getComponent("visa/created"),
    },
    {
      name: 'visa_otherPrice',
      path: '/visa_otherPrice',
      meta: {},
      component: getComponent('visa/otherPrice')
    },
    {
      name: 'pay',
      path: '/pay',
      meta: {},
      component: getComponent('home/pay')
    }
  ],
});
// 获取用户信息
const getUserInfo = () => {
  const userInStore = store.state.userInfo;
  const userInfStorage = JSON.parse(localStorage.getItem('userInfo') || 'null');
  let userInfo = userInStore || userInfStorage || null;
  return userInfo;
}
// 全局路由守卫
router.beforeEach((to, from, next) => {
  const { disableCheckUser } = to.meta;
  // 全局名称
  const { title = '常顺旅行' } = to.meta;
  document.title = `${title} - 深圳市常顺旅行社有限公司`;
  // 检测登录情况
  if ( !disableCheckUser ) {
    const userInfo = getUserInfo();
    if (!!userInfo === false || 'token' in userInfo === false ) {
      const { name, query, params, path } = to;
      const data = { name, query, params, path };
      next({ name: 'login', params: data, replace: true });
      return;
    }
  }
  next();
});

export default router;
